import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=2670c5c5&scoped=true"
import script from "./Play.vue?vue&type=script&lang=js"
export * from "./Play.vue?vue&type=script&lang=js"
import style0 from "./Play.vue?vue&type=style&index=0&id=2670c5c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2670c5c5",
  null
  
)

export default component.exports